import { useState } from "react";
import { Tab, Tabs, Box } from "@mui/material";
import { Google, Twitter, FacebookRounded, LinkedIn } from "@mui/icons-material";
import { GooglePreview } from "./GooglePreview";
import { TwitterPreview } from "./TwitterPreview";
import { FacebookPreview } from "./FacebookPreview";
import { LinkedInPreview } from "./LinkedInPreview";
import { useImageURL } from "./useImageURL";
enum SocialMediaTab {
  Google,
  Twitter,
  Facebook,
  LinkedIn,
}
type SocialMediaPreviewProps = {};
export const SocialMediaPreview = ({}: SocialMediaPreviewProps) => {
  const imageURL = useImageURL();
  const [activeTab, setActiveTab] = useState<SocialMediaTab>(SocialMediaTab.Google);
  return <>
      <Box sx={{
      mb: 1.5,
      borderBottom: theme => `2px solid ${theme?.palette?.border} `
    }} data-sentry-element="Box" data-sentry-source-file="index.tsx">
        <Tabs value={activeTab} onChange={(_, value) => setActiveTab(value)} sx={{
        position: "relative",
        top: "2px"
      }} data-sentry-element="Tabs" data-sentry-source-file="index.tsx">
          <Tab icon={<Google />} iconPosition="start" label="Google" value={SocialMediaTab.Google} data-sentry-element="Tab" data-sentry-source-file="index.tsx" />
          <Tab icon={<Twitter />} iconPosition="start" label="Twitter (X)" value={SocialMediaTab.Twitter} data-cy="SocialMediaPreviewTwitter" data-sentry-element="Tab" data-sentry-source-file="index.tsx" />
          <Tab icon={<FacebookRounded />} iconPosition="start" label="Facebook" value={SocialMediaTab.Facebook} data-sentry-element="Tab" data-sentry-source-file="index.tsx" />
          <Tab icon={<LinkedIn />} iconPosition="start" label="LinkedIn" value={SocialMediaTab.LinkedIn} data-sentry-element="Tab" data-sentry-source-file="index.tsx" />
        </Tabs>
      </Box>
      {activeTab === SocialMediaTab.Google && <GooglePreview imageURL={imageURL} />}
      {activeTab === SocialMediaTab.Twitter && <TwitterPreview imageURL={imageURL} />}
      {activeTab === SocialMediaTab.Facebook && <FacebookPreview imageURL={imageURL} />}
      {activeTab === SocialMediaTab.LinkedIn && <LinkedInPreview imageURL={imageURL} />}
    </>;
};